import { Dispatcher } from "../../../../react-core/Flux/Dispatcher";
import { FluxResponse } from "../../../Admin/Company/CompanyWizard/Stores/Variable";
import { TableColSettingsStatic } from "./TableColSettings";

export const TableColSettingsDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const TableColSettingsStore: TableColSettingsStatic = new TableColSettingsStatic();
